import { Typography } from '@mui/material';
import { DashboardCard } from 'pages/Dashboard/components/DashboardCard/DashboardCard';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Alert } from 'shared/mui/Alert/Alert';
import { TableBody, TableCell, TableHead, TableRow } from 'shared/mui/Table';
import { EntitiesSummaryItem } from 'types/embedded/dashboard';

import { TableStyled } from './DashboardEntitiesSummary.styled';
import { DashboardEntitiesSummarySkeleton } from './DashboardEntitiesSummarySkeleton';

type Props = {
  isLoading: boolean;
  entityName: string;
  title: string;
  description: string;
  items?: EntitiesSummaryItem[];
  error?: string;
};

export const DashboardEntitiesSummary: React.FC<Props> = ({
  isLoading,
  items,
  entityName,
  title,
  description,
  error,
}) => {
  const translate = useTypedTranslate();

  if (isLoading) {
    return <DashboardEntitiesSummarySkeleton />;
  }

  return (
    <DashboardCard
      cardHeaderProps={{
        description,
        title,
      }}
    >
      {error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <TableStyled>
          <TableHead
            sx={{
              backgroundColor: 'tableHead',
            }}
          >
            <TableRow>
              <TableCell className="cell-id">#</TableCell>
              <TableCell className="cell-name">{entityName}</TableCell>
              <TableCell className="cell-total">
                {translate('app.dashboard.entitiesSummary.totalTransactions')}
              </TableCell>
              <TableCell className="cell-success">
                {translate('app.dashboard.entitiesSummary.successfulTransactions')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items?.map((item, index) => (
              <TableRow key={item?.id}>
                <TableCell className="cell-id">{index + 1}</TableCell>
                <TableCell className="cell-name">{item?.name}</TableCell>
                <TableCell className="cell-total">{item?.totalTransactions}</TableCell>
                <TableCell className="cell-success">
                  {item?.successfulTransactions}{' '}
                  <Typography color="success.main" component="span">
                    ({item?.conversion}%)
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TableStyled>
      )}
    </DashboardCard>
  );
};
